<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        // 통계
        //icon(name="caret-down")
        li.list-complete-item.li-head(key="rate-label")
          icon(name="caret-down")
          span {{$t('statistics')}}
        li.list-complete-item(key="rate-summary")
          router-link.group-link(:to="{name: 'rate-summary'}")
            span {{$t('top10')}} {{$t('statistics')}}
        li.list-complete-item(key="rate-remote")
          router-link.group-link(:to="{name: 'rate-remote'}")
            span {{$t('remote.remote.title')}} {{$t('statistics')}}
        // 이력
        li.list-complete-item.li-head(key="log-label")
          icon(name="caret-down")
          span {{$t('history')}}
        li.list-complete-item(key="log-remote")
          router-link.group-link(:to="{name: 'log-remote'}")
            span {{$t('remote.remote.title')}} {{$t('history')}}
        li.list-complete-item(key="log-access")
          router-link.group-link(:to="{name: 'log-access'}")
            span {{$t('user')}} {{$t('login')}} {{$t('history')}}
        //li.list-complete-item(key="log-transfer")
        //  router-link.group-link(:to="{name: 'log-transfer'}")
        //    span {{$t('remote.transfer.title')}} {{$t('history')}}
        li.list-complete-item(key="log-delete")
          router-link.group-link(:to="{name: 'log-delete'}")
            span {{$t('deleted_device_history')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from '../mixins/sidebar'

export default {
  name: 'statistics-component',
  components: { 'sidebar': Sidebar }
}
</script>

<style lang="scss" scoped>
.group-list {
  padding: 0;
  margin: 1rem 0 0 0;
  list-style: none;
  font-size: 14px;

  li {
    height: 35px;
    line-height: 35px;

    &.li-head {
      color: #545B64;
      margin-left: 10px;
      font-weight: bold;
      > svg {
        margin-right: 10px;
      }
    }

    > a {
      > span {
        margin-left: 4px;
      }
    }

    .group-link {
      display: block;
      width: 100%;
      padding: 0 8px 0 16px;
      text-align: left;
      font-weight: 400;
      color: #6F6F6F;
      background-color: #fff;

      &.router-link-exact-active {
        color: $mainTheme;
        > span { font-weight: bolder; }
      }
      &:hover {
        // background-color: #16232d;
        color: #16191F;
      }
      > svg { vertical-align: middle; }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }

    &.active .group-link {
      background-color: #38d2b8;
      color: #fff;
    }
  }
}

.list-complete-item {
  transition: transform 500ms;
}
.list-complete-enter {
  transform: translateX(-220px);
}
.list-complete-leave-to {
  // transform: translateX(220px);
  display: none;
}
.list-complete-leave-active {
  // position: absolute;
}
</style>
